"use client"
import React, { useEffect, useState } from 'react'
import "./squareLoader.css"
import { useLoaderStore } from "@/store/store";
import { usePathname } from 'next/navigation';

function SquareLoader() {
    const { loading, setLoading } = useLoaderStore();
    const pathname = usePathname();
    const [showLoader, setShowLoader] = useState(false);
    const squareStyle = "loader-square"
    const timeoutRef = React.useRef<NodeJS.Timeout | null>(null);
  
    // Reset loader to false when page loads/changes (pathname changes)
    useEffect(() => {
        setLoading(false);
        setShowLoader(false);
        // Clear any pending timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, [pathname, setLoading]);

    useEffect(() => {
        if (loading) {
            timeoutRef.current = setTimeout(() => {
                setShowLoader(true);
            }, 300);
        } else {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
            setShowLoader(false);
        }
        
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [loading]);

    if (!showLoader) return null;
  
    return (
        <div className='fixed inset-0 flex items-center justify-center bg-black opacity-80 z-50 pointer-events-auto'>
            <div className="loader pointer-events-none">
                <div className={squareStyle}></div>
                <div className={squareStyle}></div>
                <div className={squareStyle}></div>
                <div className={squareStyle}></div>
                <div className={squareStyle}></div>
                <div className={squareStyle}></div>
                <div className={squareStyle}></div>
            </div>
        </div>
    )
}

export default SquareLoader